import React, { useState, useEffect } from 'react'
import SidebarProposal from '../../../layouts/sidebarProposal/SidebarProposal'
import { startLoading, doneLoading } from '../../../utils/loading'
import ContentHeader from '../../../components/ContentHeader/ContentHeader'
import PanalLoadingTemplate from '../../../widgets/loadingTemplate/panalLoadingTemplate/PanalLoadingTemplate'
import ErrorWidget from '../../../widgets/errorWidget/ErrorWidget'
import ListOfAssetsWidget from '../../../widgets/durableArticlesWidget/listOfAssets/ListOfAssetsWidget'
import { sessionGetItemStr } from '../../../utils/sessionHelpers'
import { getListOfAssets } from '../../../redux/actions/listOfAssets'

export default function ListOfAssetsOfficer({ step }) {
  const [schema, setSchema] = useState()
  const [isLoading, setIsLoading] = useState(false)
  const [error, setError] = useState()
  // const [isSupplyOfficer, setIsSupplyOfficer] = useState(false)

  const projectCode = sessionGetItemStr('projectCode')

  useEffect(() => {
    handleGetSchema()
  }, [])

  const handleGetSchema = async () => {
    setIsLoading(true)
    startLoading()
    try {
      const response = await getListOfAssets(projectCode, 1, 5)

      if (response) {
        setSchema(response.model)
        // if (response.model.isSupplyOfficer == 1) {
        //   setIsSupplyOfficer(true)
        // }
      } else {
        setError({})
      }
    } catch (e) {
      // console.log('error', e)
      if (e?.response?.data) {
        setError({
          statusCode: e.response.data.status,
          errorMessage: e.response.data.errors?.message,
        })
      } else {
        setError({})
      }
    }
    doneLoading()
    setIsLoading(false)
  }

  if (error) {
    return (
      <SidebarProposal isAssetCirculating>
        <ErrorWidget statusCode={error.statusCode} errorMessage={error.errorMessage} />
      </SidebarProposal>
    )
  }

  if (!schema || isLoading) {
    return (
      <SidebarProposal isAssetCirculating>
        <PanalLoadingTemplate />
      </SidebarProposal>
    )
  }

  return (
    <div>
      <SidebarProposal isAssetCirculating>
        <ContentHeader header={schema.header} subHeader={''} isNotCallApi />
        <ListOfAssetsWidget schema={schema} projectCode={projectCode} />
        <br />
      </SidebarProposal>
    </div>
  )
}
